import { render, staticRenderFns } from "./UsuarioDashboardVisitas.vue?vue&type=template&id=54dfc887&scoped=true"
import script from "./UsuarioDashboardVisitas.vue?vue&type=script&lang=js"
export * from "./UsuarioDashboardVisitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfc887",
  null
  
)

export default component.exports